<template>
  <div :style="skin.my_account.close_btn">
    <div class="p-2" :style="skin.my_account.menu_item_border">
      <h5>{{translate("pay_withdrawal")}}</h5>
    </div>
    
    <div v-if="response.result=='Ok'" class="alert alert-success fade show" role="alert">
      {{ response.msg }}
    </div>
    <div v-if="response.result=='error'" class="alert alert-danger fade show" role="alert">
      {{ response.msg }}
    </div>
    <div class="row p-2">
        <form @submit.prevent="confirmWithdraw()" class="col-12 col-lg-6">
          <div class="py-2">
            <label for="code">{{translate("withdrawal_code")}}</label>
            <input v-model="code" type="text" class="form-control" :placeholder="translate('enter_withdrawal_code')" id="code" required>
          </div>
          <div class="py-2">
            <label for="notes">{{translate("notes")}}</label>
            <input v-model="notes" type="text" class="form-control" id="notes" :placeholder="translate('annotations')">
          </div>
          <div class="py-4">
            <button :style="skin.qbet.booking_btn" class="p-2 text-center mb-2" style="width:100%;color:white" :disabled="payment_inProcess">{{translate("confirm")}}</button>
          </div>
        </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
    name:"withdraw",
    props:["skin","language","translation"],
    data(){
      return{
        payment_inProcess:false,
        code:"",
        notes:"",
        response:{result:"",msg:""},
        loading: false,
        cardName: 'Alejandra Castañeda',
        cardEmail: 'marialejac120@gmail.com',
        selectedBank: '',
        usuTelefono: "3157210552",
        usuTipdoc: "CC",
        numCuenta: "3157210552",
        tipoCuenta: "AHORRO",
        cuentaType: ["AHORRO", "CORRIENTE"],
        docs: ['CC', 'NIT'],
        pix_key_types: ['CPF', 'CNPJ', 'PHONE', 'EMAIL', 'EVP'],
        "tax_id": "1005152284",
        "pix_key_type": "",
        "pix_key": "",
        transactionFeesUrl: 'https://docs.0xprocessing.com/basic/general/transaction-fees', // URL para ver las Transaction Fees
        amount: 1.0,
        address: '',
        selectedMethod: 'PIX', // Moneda seleccionada
        methods: ['CRIPTO', 'PIX', 'CUENTA DE AHORROS'],
        login_inProcess: false,
      }
    },
    methods:{
      async confirmWithdraw(){
        this.payment_inProcess = true
        let data = {
          "command":"pagar",
          "params":{
            "codigo":this.code,
            "notas":this.notes
            }
          }

        const response = await axios.post(this.user.domain+'/'+this.user.prefix+'/scommand?access_token='+this.user.token+'&site='+this.user.site,data);
        if(response.data.result == 'Ok'){
          this.response.result="Ok";
          this.response.msg=response.data.msg;
          this.code="";
          this.notes="";
        }
        else if(response.data.result == 'error'){
          this.response.result="error";
          this.response.msg=response.data.msg;
        }
        this.payment_inProcess = false;
      },
      async withdraw_pix() {
        this.status.message = "";
        this.status.type = "";

        // Validar campos obligatorios
        if (!this.pix_key_type || !this.pix_key || !this.tax_id) {
            this.status.message = this.translate("All fields are required");
            this.status.type = "danger";
            return;
        }

        // Expresiones regulares para validar formatos
        const regexCPF = /^(?:\d{3}\.\d{3}\.\d{3}-\d{2}|\d{11})$/;
        const regexCNPJ = /^(?:\d{2}\.\d{3}\.\d{3}\/0001-\d{2}|\d{14})$/;
        const regexPhone = /^(?:\+55\d{11,12}|\d{10,11})$/;
        const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const regexEVP = /^[a-fA-F0-9-]{36}$/;

        // Validar tax_id según el país
        if (!regexCPF.test(this.tax_id) && !regexCNPJ.test(this.tax_id)) {
            this.status.message = this.translate("Invalid tax ID format");
            this.status.type = "danger";
            return;
        }

        // Validar pix_key según el tipo seleccionado
        switch (this.pix_key_type) {
            case "CPF":
                if (!regexCPF.test(this.pix_key)) {
                    this.status.message = this.translate("Invalid CPF format");
                    this.status.type = "danger";
                    return;
                }
                break;
            case "CNPJ":
                if (!regexCNPJ.test(this.pix_key)) {
                    this.status.message = this.translate("Invalid CNPJ format");
                    this.status.type = "danger";
                    return;
                }
                break;
            case "PHONE":
                if (!regexPhone.test(this.pix_key)) {
                    this.status.message = this.translate("Invalid phone format");
                    this.status.type = "danger";
                    return;
                }
                break;
            case "EMAIL":
                if (!regexEmail.test(this.pix_key)) {
                    this.status.message = this.translate("Invalid email format");
                    this.status.type = "danger";
                    return;
                }
                break;
            case "EVP":
                if (!regexEVP.test(this.pix_key)) {
                    this.status.message = this.translate("Invalid EVP format");
                    this.status.type = "danger";
                    return;
                }
                break;
            default:
                this.status.message = this.translate("Invalid PIX key type");
                this.status.type = "danger";
                // this.$store.commit("getPayment",{error:"Invalid PIX key type"})
                return;
        }

        this.loading = true;
        this.status.message = this.translate("");

        // Enviar datos al store Vuex
        this.$store.dispatch("setAmountPix", {
            data: {
                tax_id_country: "BRA",
                tax_id: this.tax_id,
                pix_key_type: this.pix_key_type,
                pix_key: this.pix_key
            },
            amount: parseFloat(this.amount)
        });

        setTimeout(async () => {
            await this.$store.dispatch("getPixWithdraw");
        }, 200);

        setTimeout(async () => {
            this.loading = false;
            if (!this.withdrawDataForm.error) {
                this.status.message = this.translate("Withdrawal request sent successfully");
                this.status.type = "success";
            }
            setTimeout(async () => {
                document.getElementById("closeLoginW").click();
            }, 1000);
        }, 2000);
    },
      translate(text) {
        if(text){
          if (this.$props.translation[text]) {
            return this.$props.translation[text][this.$props.language];
          }
          else{
            var new_text_serched = text.replace(/ /g, "_");
            if (this.$props.translation[new_text_serched]) {
              return this.$props.translation[new_text_serched][this.$props.language];
            }
          }
          return text;
        }
      },
    },
    computed:{
      user(){
        return this.$store.getters['getUserData'];
      },
    }
}
</script>

<style>

</style>